import React , { useContext, useState, useEffect } from 'react';
import { Row , Col , Container} from 'react-bootstrap';
import NavDefault from '../layout/Nav';
import BenefitCodeCard from '../BenefitCode';
import FooterDefault from '../layout/Footer';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import New from '../../components/maintenance/New';
import { UserContext } from '../../UserContext';

import  secureLocalStorage  from  "react-secure-storage";

const Home = () => {

    //const {activeModule,setActiveModule} = useContext(UserContext);

    //secureLocalStorage.setItem("activeModule","2");

    return(
        <>
        <NavDefault></NavDefault>

        <Container fluid className="mt-4 "  >
            <Row>
                <Col  sm={2} md={2} >

                </Col>
                <Col sm={9} md={9} lg={9}>
                <Tabs
                    defaultActiveKey="profile"
                    id="fill-tab-example"
                    className="mt-3"
                    fill="true"
                    >
                    <Tab eventKey="home" title="Beneficios">
                        <BenefitCodeCard/>
                    </Tab>
                    <Tab eventKey="profile" title="Servicios">
                        <New></New>
                    </Tab>
                </Tabs>

                </Col>
                <Col sm={1} md={1} lg={1}>
                </Col>
            </Row>
        </Container>
        <FooterDefault />

        </>

    )
}
export default Home;